module.exports = __webpack_public_path__ + "img/controle.30da5784.svg";